
import {initWebComponent} from "@/helpers/web-component-helper";
import {removeMeasure, startCesiumMeasure} from "@/modules/cesium/cesium-measure";
import {toggleAllowCameraUnderTerrain} from "@/modules/cesium/cesium";
import {initBoostrapSlider} from "@/helpers/bootstrap-slider-helper";

const template = document.createElement('template');
template.innerHTML = `
<div class="row">
    <div class="col-6">Transparantie</div>
    <div class="col-6">
        <div class="slider-primary pl-1 pr-2">
            <input
                id="cesiumTerrainSlider"
                class="bs-slider-variant"
                type="text"
                data-provide="slider"
                data-slider-min="0"
                data-slider-max="100"
                data-slider-step="1"
                data-slider-value="100"
                data-slider-tooltip="hide"
            >
        </div>
    </div>
</div>`;

export class CesiumTerrainTransparencyComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        initBoostrapSlider('cesiumTerrainSlider')
    }
}

